module.exports = __webpack_public_path__ + "static/img/101850.3a2b5c0b.png";